import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { sortBy } from "lodash";

import * as callActions from "../../../actions/callActions";

import DestinationSideFilters from "./DestinationSideFilters";
import CallList from "./CallList";

const DEFAULT_FILTERS = {
  customer: {},
  project: {},
  call_type: {}
};

const DestinationSide = ({
  calls,
  onCallClick,
  onStartMigration,
  needResetFiltersDestination,
  setNeedResetFiltersDestination,
  saving,
  onSetDestinationCalls,
  projects,
  customerId
}) => {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  useEffect(() => {
    if (needResetFiltersDestination) {
      setFilters(DEFAULT_FILTERS);
      setNeedResetFiltersDestination(false);
    }
  }, [needResetFiltersDestination, setNeedResetFiltersDestination]);

  const handleChangeFilters = (field, value) => {
    setFilters((prev) => {
      const newValues = { [field]: value };
      if (field === "project") {
        const project = projects?.find((proj) => proj._id === value?.value);
        newValues.call_type = {
          value: project?.call_type._id,
          label: project?.call_type.label
        };
      }
      return {
        ...prev,
        ...newValues
      };
    });
  };

  const handleResetFilters = () => {
    setFilters(DEFAULT_FILTERS);
  };

  const handleSortCalls = (field, direction) => {
    onSetDestinationCalls((prev) => {
      const newCalls = sortBy(prev, [field]);
      if (direction === "desc") {
        return newCalls.reverse();
      }
      return newCalls;
    });
  };

  return (
    <div>
      <h4 style={{ paddingLeft: 15 }}>Destination</h4>
      <DestinationSideFilters
        customerId={customerId}
        filters={filters}
        saving={saving}
        onChangeFilters={handleChangeFilters}
        onResetFilters={handleResetFilters}
        onStartMigration={() => onStartMigration(filters)}
      />
      <div className="content-wrapper overflowX">
        <CallList
          onSortedChange={handleSortCalls}
          onCallClick={onCallClick}
          calls={calls}
          heightDiff={440}
          noRowsRenderer={() => (
            <div className="no-rows-selected">
              <h3>No rows selected</h3>
            </div>
          )}
        />
      </div>
    </div>
  );
};

DestinationSide.propTypes = {
  calls: PropTypes.array,
  onCallClick: PropTypes.func,
  onStartMigration: PropTypes.func,
  needResetFiltersDestination: PropTypes.bool,
  setNeedResetFiltersDestination: PropTypes.func,
  saving: PropTypes.bool,
  onSetDestinationCalls: PropTypes.func,
  projects: PropTypes.array,
  customerId: PropTypes.string
};

DestinationSide.defaultProps = {
  calls: [],
  onCallClick: () => null,
  onStartMigration: () => null,
  saving: false,
  onSetDestinationCalls: () => null,
  customerId: ""
};

function mapStatesToProps(state) {
  return {
    projects: state.reducers.projects
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...callActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(DestinationSide);
